import { render } from "./instructor-quiz-modal.vue?vue&type=template&id=89721226"
import script from "./instructor-quiz-modal.vue?vue&type=script&lang=js"
export * from "./instructor-quiz-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__